<template>
  <tr>
    <td
      :class="[message.isRead ? 'read-icon' : 'unread-icon']"
      class="icon"
    />
    <td class="title">
      <!-- 当文字长度大于19个时(出现省略号),有popover提示框 -->
      <ElPopover
        v-model="state"
        v-if="message.title.length > 19"
        placement="bottom-start"
        width="390"
        trigger="hover"
        transition=""
        :content="message.title"
        :open-delay="1000"
      >
        <a
          slot="reference"
          @mousewheel="state=false"
          :class="[message.isRead ? 'read-color' : 'unread-color']"
          :href="message.link"
          class="content"
        >
          {{ message.title }}
        </a>
      </ElPopover>
      <!-- 没有出现省略号,就不出现提示框 -->
      <a
        v-else
        slot="reference"
        :class="[message.isRead ? 'read-color' : 'unread-color']"
        :href="message.link"
        class="content"
      >
        {{ message.title }}
      </a>
    </td>
    <td class="time">
      {{ message.time | formatTime }}
    </td>
  </tr>
</template>

<script>
import { formatTime } from '@/utils/time';

export default {
  filters: {
    formatTime: time => formatTime(new Date(time)),
  },
  props: {
    message: {
      type: Object,
      default: () => ({
        isread: false,
        title: '默认消息!',
        time: '00:00',
        link: 'https://baidu.com',
      }),
    },
  },
  data() {
    return {
      state: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/message.scss";
tr {
  .icon {
    display: inline-block;
    margin-left: -8px;
    margin-top: 14px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: $danger;
  }
  .title{
    width: 90%;
  }
}
</style>
